@let $control = control();

@if ($control) {
  <app-editable
    #editable
    [editMode]="editMode()"
    [valid]="$control.dirty && $control.valid"
    (saving)="save($event)"
    (saved)="commit()"
    (canceled)="cancel()"
    (editing)="editable.focus(input)"
  >
    <input type="text"
           editContent
           #input
           [placeholder]="placeholder()"
           [formControl]="$control"
           (keyup.enter)="editable.save()"
           (keyup.escape)="editable.cancel()"
    >

    <input type="text" readonly viewContent [value]="$control.value">
  </app-editable>
}
